var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.391,
    height: 102.983,
    viewBox: "0 0 199.391 102.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".blue{fill:#c0e9ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blue",
    d: "M157.78,95.272c1.364,9.889,1.131,13.511,11.028,25.129s27.057,18.443,45.359,18.943,39.334-8.537,46.781-18.943,43.076,5.2,53.445,5.909c11.878.813,38.037-.72,41.4-14.1,6.962-22.756-26.38-45.2-54.124-43.712s-23.965,11.561-30.9-2.3-37.579-26.284-46.395-27.833S194.5,30.854,175.82,51.613,156.416,85.382,157.78,95.272Z",
    transform: "translate(-157.338 -36.38)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCloud);
export default __webpack_public_path__ + "static/media/blue-cloud.7f818e018827db65dbc0443daa5bcf24.svg";
export { ForwardRef as ReactComponent };